// Where FlowStock publishes the products it creates (W4). Stored as channel names in
// config_object.platform.shopify.publishable_channels; the sync workers match them against
// the store's publications. Absent or empty means Online Store only — keep that default in
// step with DEFAULT_SALES_CHANNELS in the workers' sales_channels.ts.

export const DEFAULT_SALES_CHANNELS = ['Online Store']

export function savedSalesChannels(config: any): string[] {
  const raw = config?.platform?.shopify?.publishable_channels
  const names = Array.isArray(raw) ? raw.map((n: unknown) => String(n ?? '').trim()).filter(Boolean) : []
  return names.length > 0 ? names : DEFAULT_SALES_CHANNELS
}

/** Toggle one channel; the last one cannot be removed (nothing would ever be visible). */
export function toggleSalesChannel(current: string[], name: string): string[] {
  if (current.includes(name)) return current.length > 1 ? current.filter((n) => n !== name) : current
  return [...current, name]
}

/** The platform block with the channel list set, every other key preserved. */
export function platformWithSalesChannels(platform: any, channels: string[]): any {
  return {
    ...(platform || {}),
    shopify: { ...(platform?.shopify || {}), publishable_channels: channels },
  }
}

/** Saved names the store no longer offers (renamed or removed channel) — shown, not dropped. */
export function unknownSalesChannels(saved: string[], available: string[] | null): string[] {
  if (!available) return []
  const have = new Set(available.map((n) => n.toLowerCase()))
  return saved.filter((n) => !have.has(n.toLowerCase()))
}
